module.exports = __webpack_public_path__ + "img/Moduuli_3_minimihinta.4c7b7ac7.png";